export const statusStock = [
    {
        value: "NOT_AVAILABLE",
        name: "n/a",
    },
    {
        value: "READY",
        name: "ready",
    },
    {
        value: "INDENT",
        name: "indent",
    },
    {
        value: "INDENT3",
        name: "indent 3 day",
    },
    {
        value: "INDENT7",
        name: "indent 7 day",
    },
    {
        value: "INDENT14",
        name: "indent 14 day",
    },
];
export const dataSource = [
    {
        company_code: "AMARTA",
        dealer_code: "DLR#HND#01400",
        dealer_name: "PT ARIMBI AMARTAPURA",
        data_location: "https://otodis-bucket.s3.ap-southeast-1.amazonaws.com/json_stock/DLR%23HND%2301400.json",
    },
    {
        company_code: "AMARTA",
        dealer_code: "DLR#HND#01369",
        dealer_name: "PT AMARTA SAYAP MERAH PADALARANG",
        data_location: "https://otodis-bucket.s3.ap-southeast-1.amazonaws.com/json_stock/DLR%23HND%2301369.json",
    },
    {
        company_code: "AMARTA",
        dealer_code: "DLR#HND#06834",
        dealer_name: "PT AMARTA SAYAP MERAH BEKASI",
        data_location: "https://otodis-bucket.s3.ap-southeast-1.amazonaws.com/json_stock/DLR%23HND%2306834.json",
    },
    {
        company_code: "AMARTA",
        dealer_code: "DLR#HND#12293",
        dealer_name: "PT AMARTA SAYAP MERAH CIREBON",
        data_location: "https://otodis-bucket.s3.ap-southeast-1.amazonaws.com/json_stock/DLR%23HND%2312293.json",
    },
    {
        company_code: "AMARTA",
        dealer_code: "DLR#HND#12294",
        dealer_name: "PT AMARTA SAYAP MERAH KUNINGAN",
        data_location: "https://otodis-bucket.s3.ap-southeast-1.amazonaws.com/json_stock/DLR%23HND%2312294.json",
    },
    {
        company_code: "AMARTA",
        dealer_code: "DLR#HND#12730",
        dealer_name: "PT AMARTA MULTI DINAMIKA MANADO",
        data_location: "https://otodis-bucket.s3.ap-southeast-1.amazonaws.com/json_stock/DLR%23HND%2312730.json",
    },
    {
        company_code: "AMARTA",
        dealer_code: "DLR#HND#15925",
        dealer_name: "PT AMARTA MULTI DINAMIKA GORONTALO",
        data_location: "https://otodis-bucket.s3.ap-southeast-1.amazonaws.com/json_stock/DLR%23HND%2315925.json",
    },
    {
        company_code: "AMARTA",
        dealer_code: "DLR#HND#99999",
        dealer_name: "AMV JAKARTA",
        data_location: "https://otodis-bucket.s3.ap-southeast-1.amazonaws.com/json_stock/DLR%23HND%2399999.json",
    },
    {
        company_code: "AMARTA",
        dealer_code: "DLR#HND#99998",
        dealer_name: "AMV TANGERANG",
        data_location: "https://otodis-bucket.s3.ap-southeast-1.amazonaws.com/json_stock/DLR%23HND%2399998.json",
    }
];
